export const PULSARA_MODULE_ID = 98

export enum PulsaraConstants {
  NOT_IMPLEMENTED = 'pulsara/NOT_IMPLEMENTED',
  SET_CURRENT_STEP = 'pulsara/SET_CURRENT_STEP',
  SET_CURRENT_SUB_STEP = 'pulsara/SET_CURRENT_SUB_STEP',
  RESET_PULSARA = 'pulsara/RESET_PULSARA',
  SET_LOADING = 'pulsara/SET_LOADING',
  SET_SELECTED_PULSARA_ID = 'pulsara/SET_SELECTED_PULSARA_ID',
  FETCH_PULSARA_RECORDS = 'pulsara/FETCH_PULSARA_RECORDS',
  FETCH_PULSARA_DETAILS = 'pulsara/FETCH_PULSARA_DETAILS',
  FETCH_PULSARA_ATTACHMENTS = 'pulsara/FETCH_PULSARA_ATTACHMENTS',
  FETCH_PULSARA_ATTACHMENT_IMAGE = 'pulsara/FETCH_PULSARA_ATTACHMENT_IMAGE',
  SET_PULSARA_RECORDS = 'pulsara/SET_PULSARA_RECORDS',
  SET_PULSARA_DETAILS = 'pulsara/SET_PULSARA_DETAILS',
  SET_PULSARA_ATTACHMENTS_LIST = 'pulsara/SET_PULSARA_ATTACHMENTS_LIST',
  SET_PULSARA_ATTACHMENTS = 'pulsara/SET_PULSARA_ATTACHMENTS',
  SET_SELECTED_VITALS = 'pulsara/SET_SELECTED_VITALS',
  SET_SELECTED_LABS = 'pulsara/SET_SELECTED_LABS',
  SET_SELECTED_ATTACHMENTS = 'pulsara/SET_SELECTED_ATTACHMENTS',
  SET_IMPORT_SELECTIONS = 'pulsara/SET_IMPORT_SELECTIONS',
  SET_PATIENT_SELECTIONS = 'pulsara/SET_PATIENT_SELECTIONS',
  SET_EMS_CHARTS_DATA = 'pulsara/SET_EMS_CHARTS_DATA',
  POPULATE_EMS_CHARTS_FROM_PCR = 'pulsara/POPULATE_EMS_CHARTS_FROM_PCR',
  SET_PULSARA_STATE = 'pulsara/SET_PULSARA_STATE',
  IMPORT_PULSARA_DATA = 'pulsara/IMPORT_PULSARA_DATA',
  GET_PULSARA_ATTACHMENTS = 'pulsara/GET_PULSARA_ATTACHMENTS',
  DELETE_PULSARA_ATTACHMENT = 'pulsara/DELETE_PULSARA_ATTACHMENT',
  HANDLE_RESETS_ON_BACK = 'pulsara/HANDLE_RESETS_ON_BACK',
}
